module.exports = __webpack_public_path__ + "img/isotipo-M-white.24e3bcca.svg";